import React, { useState, useEffect } from "react";
import "./ScrollToTopButton.css";

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            setVisible(window.scrollY > 250);
        };

        window.addEventListener("scroll", toggleVisibility);
        toggleVisibility();

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        visible && (
            <button
                className="scroll-to-top"
                onClick={scrollToTop}
                aria-label="Scroll to top"
                title="Back to top"
            >
                <span className="scroll-to-top__icon" aria-hidden="true">
                    {"\u2191"}
                </span>
            </button>
        )
    );
};

export default ScrollToTopButton;
